const onArrowRight =
  (handler) =>
  (e, ...args) => {
    if (e.key === 'ArrowRight') {
      handler(e, ...args);
    }
  };

export default onArrowRight;
